export const BuildInfo = {timestamp:1782944787000}
